import { Core } from "@faire/design-tokens";
import { Upload } from "@faire/web/slate/icons/foundation/Upload";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var FileUploaderStatus = function FileUploaderStatus(_ref) {
  var uploadCta = _ref.uploadCta,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$showFileIcon = _ref.showFileIcon,
    showFileIcon = _ref$showFileIcon === void 0 ? true : _ref$showFileIcon;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
      color: Core.icon.subdued
    }), uploadCta ? /*#__PURE__*/React.createElement(LoadingMessage, null) : null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, showFileIcon ? /*#__PURE__*/React.createElement(Upload, {
    color: "inherit",
    fontSize: "24px"
  }) : null, uploadCta ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "1x"
  }), typeof uploadCta === "string" ? ( /*#__PURE__*/React.createElement(Typography, {
    color: error ? Core.text.critical : "inherit",
    align: "center"
  }, uploadCta)) : ( /*#__PURE__*/React.createElement(React.Fragment, null, uploadCta)))) : null);
};
var LoadingMessage = function LoadingMessage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    align: "center"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rZ+nel",
    defaultMessage: [{
      "type": 0,
      "value": "Uploading..."
    }]
  })));
};